export enum GlobalModalType {
  FastOrder = 'fastOrder',
  ChatLimit = 'chatLimit',
}
